import validate_pt from "vee-validate/dist/locale/pt_BR";
import validate_en from "vee-validate/dist/locale/en";
import validate_es from "vee-validate/dist/locale/es";
import validate_de from "vee-validate/dist/locale/de";
import validate_zh from "vee-validate/dist/locale/zh_CN";
import validate_id from "vee-validate/dist/locale/id";
import Vue from "vue";
import VueI18n from "vue-i18n";
import pt from "./pt.json";
import en from "./en.json";
import es from "./es.json";
import de from "./de.json";
import zh from "./zh.json";
import id from "./id.json";

export const Routes = {
  home: {
    pt: "inicio",
    es: "inicio",
    en: "home",
    de: "startseite",
    zh: "shouye",
    id: "beranda",
  },
  report: {
    pt: "denunciar",
    es: "informe",
    en: "report",
    de: "melden",
    zh: "jubao",
    id: "laporan",
  },
  reportAlt: {
    pt: "comunicar",
    es: "informe",
    en: "report",
    de: "melden",
    zh: "jubao",
    id: "laporan",
  },
  "questions-and-suggestions": {
    pt: "duvidas-e-sugestoes",
    es: "perguntas-y-sugerencias",
    en: "question-and-suggestions",
    de: "fragen-und-anregungen",
    zh: "wenti-he-jianyi",
    id: "pertanyaan-dan-saran",
  },
  "data-subject-access-request": {
    pt: "dados-pessoais",
    es: "datos-personales",
    en: "data-subject-access-request",
    de: "personenbezogene-daten",
    zh: "geren-shuju",
    id: "data-pribadi",
  },
  ombudsman: {
    pt: "ouvidoria",
    es: "ouvidoria",
    en: "ombudsman",
    de: "ombudsstelle",
    zh: "jiandu",
    id: "ombudsman",
  },
  "follow-up": {
    pt: "acompanhar",
    es: "seguir",
    en: "follow-up",
    de: "nachverfolgen",
    zh: "genzong",
    id: "tindak-lanjut",
  },
};

export const ValidatorDictionary = {
  pt: {
    name: "pt",
    messages: validate_pt.messages,
    attributes: {
      email: "E-mail",
      fullName: "Nome Completo",
      position: "Cargo / Função",
      relatedOffice: "Posto",
      communicationType: "Tipo de Comunicação",
      origin: "Origem da comunicação",
      reportingAgent: "Vínculo com a organização",
      level: "Classificação",
      nature: "Natureza da Comunicação",
      involvedDepartment: "Setor da Ocorrência",
      businessUnit: "Unidade/Posto/Filial",
      channelConfidence: "Confiança no Canal",
      businessGroup: "Empresa",
      relatedProject: "Contrato / Projeto / Setor",
      cpf: "CPF",
      phone: "Telefone",
      birthday: "Data Nascimento",
      previousProtocol: "Protocolo anterior",
      complaintText: "denúncia",
      complaintDate: "data",
      complaintLocation: "local",
      communication: "comunicação",
      complaintKnowAbout: "conhecimento",
      complaintWitnesses: "testemunhas",
      complaintFinancialInfo: "dados financeiros",
      protocol: "Protocolo",
      qasText: "dúvida/sugestão",
      qasRelation: "vínculo",
      response: "Informações adicionais e respostas.",
      information: "Informação",
      dsarText: "solicitaçao",
      typology: "Tipologia",
      denouncedRelation: "Cargo do denunciado",
    },
  },
  en: {
    name: "en",
    messages: validate_en.messages,
    attributes: {
      email: "E-mail",
      fullName: "Full Name",
      position: "Position / Function",
      communicationType: "Communication Type",
      origin: "Communication Origin",
      reportingAgent: "Affiliation with the organization",
      level: "Classification",
      nature: "Nature of Communication",
      involvedDepartment: "Occurrence Sector",
      businessUnit: "Unit/Post/Branch",
      channelConfidence: "Channel Confidence",
      businessGroup: "Business Group",
      relatedProject: "Contract / Project / Sector",
      relatedOffice: "Office",
      communication: "communication",
      cpf: "CPF",
      phone: "Phone",
      birthday: "Birthday",
      previousProtocol: "Previous protocol",
      complaintText: "complaint",
      complaintDate: "date",
      complaintLocation: "location",
      complaintKnowAbout: "know about",
      complaintWitnesses: "witnesses",
      complaintFinancialInfo: "financial info",
      protocol: "Protocol",
      qasText: "question/suggestion",
      qasRelation: "relation",
      response: "Response",
      dsarText: "request",
      information: "Information",
    },
  },
  es: {
    name: "es",
    messages: validate_es.messages,
    attributes: {
      email: "E-mail",
      fullName: "Nombre Completo",
      position: "Posición / Función",
      communicationType: "Tipo de Comunicación",
      origin: "Origen de la comunicación",
      reportingAgent: "Afiliación con la organización",
      level: "Rango",
      nature: "Naturaleza de la comunicación",
      involvedDepartment: "Sector de ocurrencia",
      businessUnit: "Unidad/Puesto/Sucursal",
      channelConfidence: "Confianza del Canal",
      businessGroup: "Empresa",
      relatedProject: "Contrato / Proyecto / Sector",
      relatedOffice: "Oficina",
      communication: "comunicación",
      cpf: "CPF",
      phone: "Teléfono",
      birthday: "Fecha de Nacimiento",
      previousProtocol: "Protocolo anterior",
      complaintText: "denuncia",
      complaintDate: "fecha",
      complaintLocation: "sitio",
      complaintKnowAbout: "conocimiento",
      complaintWitnesses: "testigos",
      complaintFinancialInfo: "Datos financieros",
      protocol: "Protocolo",
      qasText: "duda/sugerencia",
      qasRelation: "enlace",
      response: "Responder",
      dsarText: "solicitación",
      information: "Información",
    },
  },
  de: {
    name: "de",
    messages: validate_de.messages,
    attributes: {
      email: "E-Mail",
      fullName: "Vollständiger Name",
      position: "Position / Funktion",
      communicationType: "Kommunikationsart",
      origin: "Kommunikationsursprung",
      reportingAgent: "Zugehörigkeit zur Organisation",
      level: "Klassifizierung",
      nature: "Art der Mitteilung",
      involvedDepartment: "Betroffene Abteilung",
      businessUnit: "Einheit/Standort/Filiale",
      channelConfidence: "Kanalvertrauen",
      businessGroup: "Unternehmen",
      relatedProject: "Vertrag / Projekt / Abteilung",
      relatedOffice: "Büro",
      communication: "Mitteilung",
      cpf: "CPF",
      phone: "Telefon",
      birthday: "Geburtsdatum",
      previousProtocol: "Vorheriges Protokoll",
      complaintText: "Meldung",
      complaintDate: "Datum",
      complaintLocation: "Ort",
      complaintKnowAbout: "Kenntnis",
      complaintWitnesses: "Zeugen",
      complaintFinancialInfo: "Finanzdaten",
      protocol: "Protokoll",
      qasText: "Frage/Anregung",
      qasRelation: "Beziehung",
      response: "Antwort",
      dsarText: "Anfrage",
      information: "Information",
    },
  },
  zh: {
    name: "zh",
    messages: validate_zh.messages,
    attributes: {
      email: "电子邮件",
      fullName: "全名",
      position: "职位/职能",
      communicationType: "通讯类型",
      origin: "通讯来源",
      reportingAgent: "与组织的关系",
      level: "级别",
      nature: "通讯性质",
      involvedDepartment: "发生部门",
      businessUnit: "单位/岗位/分支",
      channelConfidence: "渠道信任度",
      businessGroup: "企业",
      relatedProject: "合同/项目/部门",
      relatedOffice: "办公室",
      communication: "通讯",
      cpf: "CPF",
      phone: "电话",
      birthday: "出生日期",
      previousProtocol: "之前的协议",
      complaintText: "举报",
      complaintDate: "日期",
      complaintLocation: "地点",
      complaintKnowAbout: "了解情况",
      complaintWitnesses: "证人",
      complaintFinancialInfo: "财务信息",
      protocol: "协议编号",
      qasText: "问题/建议",
      qasRelation: "关系",
      response: "回复",
      dsarText: "请求",
      information: "信息",
    },
  },
  id: {
    name: "id",
    messages: validate_id.messages,
    attributes: {
      email: "Email",
      fullName: "Nama Lengkap",
      position: "Posisi / Fungsi",
      communicationType: "Jenis Komunikasi",
      origin: "Asal Komunikasi",
      reportingAgent: "Afiliasi dengan organisasi",
      level: "Peringkat",
      nature: "Sifat Komunikasi",
      involvedDepartment: "Sektor Kejadian",
      businessUnit: "Unit/Pos/Cabang",
      channelConfidence: "Kepercayaan Saluran",
      businessGroup: "Perusahaan",
      relatedProject: "Kontrak / Proyek / Sektor",
      relatedOffice: "Kantor",
      communication: "Komunikasi",
      cpf: "CPF",
      phone: "Telepon",
      birthday: "Tanggal Lahir",
      previousProtocol: "Protokol sebelumnya",
      complaintText: "Laporan",
      complaintDate: "Tanggal",
      complaintLocation: "Lokasi",
      complaintKnowAbout: "Pengetahuan",
      complaintWitnesses: "Saksi",
      complaintFinancialInfo: "Informasi Keuangan",
      protocol: "Protokol",
      qasText: "Pertanyaan/Saran",
      qasRelation: "Hubungan",
      response: "Tanggapan",
      dsarText: "Permintaan",
      information: "Informasi",
    },
  },
};

const messages = {
  pt,
  es,
  en,
  de,
  zh,
  id,
};

Vue.use(VueI18n);

// Create VueI18n instance with options
export const i18n = new VueI18n({
  locale: "pt", // set locale
  messages, // set locale messages
});
